module.exports = __webpack_public_path__ + "static/img/SketchPng3cf61ce395c74f98272ed55b67d3e840760e740b739b579e3bf524065a09a976.e6283b8f.png";